<template>
  <div id="app">
    <Header></Header>

    <Page no-image>
      <div class="pb-8 px-content pt-8">
        <h2 class="subheadline">Sicherheit, die sich sehen lassen kann</h2>
        <div class="flex justify-center">
          <h1 class="headline">Handläufe</h1>
        </div>

        <p class="mt-4 font-semibold text-gray-800">
          Ein guter Handlauf gibt Halt, aber eben nicht nur. Er begleitet
          Bewegungen, sorgt für Sicherheit im Alltag und kann gleichzeitig ein
          dezentes Gestaltungselement sein, das sich harmonisch ins Gesamtbild
          einfügt.
        </p>

        <p class="mt-4 text-gray-700">
          Ob mit Wandbefestigung oder auf Pfosten montiert – wir fertigen
          Handläufe passgenau für Ihren Innen- oder Außenbereich. Für
          zusätzliche Orientierung und stimmungsvolles Licht integrieren wir auf
          Wunsch eine LED-Beleuchtung, ganz unauffällig eingebaut und natürlich
          energieeffizient.
        </p>

        <p class="mt-4 text-gray-700">
          Bei der Ausführung stehen Ihnen verzinkte, pulverbeschichtete oder
          Edelstahl-Varianten zur Verfügung, jeweils robust, langlebig und
          abgestimmt auf Stil und Einsatzort. So entsteht aus einem funktionalen
          Detail ein durchdachtes Element, das Sicherheit, Komfort und Design
          auf elegante Weise verbindet.
        </p>

        <PhotoGallery :images="images" class="mt-8 mb-4" />
      </div>

      <ProduktKontaktformular product="Handläufe" pixelEvent="FormHandlaeufeSent" />

      <CallToAction></CallToAction>
    </Page>

    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../../components/Header.vue";
import Footer from "../../components/Footer.vue";
import CallToAction from "../../components/CallToAction.vue";
import Page from "../../components/Page.vue";
import PhotoGallery from "../../components/PhotoGallery.vue";
import ProduktKontaktformular from "../../components/ProduktKontaktformular.vue";

export default {
  name: "app",
  components: {
    Header,
    Footer,
    CallToAction,
    Page,
    PhotoGallery,
    ProduktKontaktformular,
  },
  data() {
    return {
      images: [
        { src: "img/produkte/handlaeufe/1.jpg", alt: "Handlauf 1" },
        { src: "img/produkte/handlaeufe/2.jpg", alt: "Handlauf 2" },
        { src: "img/produkte/handlaeufe/3.jpg", alt: "Handlauf 3" },
        { src: "img/produkte/handlaeufe/4.jpg", alt: "Handlauf 4" },
        { src: "img/produkte/handlaeufe/5.jpg", alt: "Handlauf 5" },
      ],
    };
  },
};
</script>

<style src="../../assets/css/comfortaa.css"></style>
<style src="../../assets/css/styles.css"></style>
